export default __webpack_public_path__ + "static/media/loading.91319f38.gif";